export default "__VITE_ASSET__yToUwaco__"